/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
import React, {useEffect, useState} from 'react';
import theme from '../../../global/styles/theme';
import TextDefault from '../../../components/TextDefault';
import {StatusBarContainer} from '../../../components/StatusBar';
import * as S from './styles';
import {RootState} from '../../../store';
import {useDispatch, useSelector} from 'react-redux';
import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import Button from '../../../components/Button';
import {priceUnmask} from '../../../utils/functions';
import {bidAuctions, getAuctions} from '../../../services/auctions';
import DefaultModal from '../../../components/DefaultModal';
import Input from '../../../components/Input';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {schemaGavelBid} from '../../../utils/schema';
import Toast from 'react-native-toast-message';
import {toastConfig} from '../../../components/Toast';
import {useIsFocused} from '@react-navigation/native';
import GavelItem from '../../../components/GavelItem';
import {updateUser} from '../../../store/modules/user/actions';
import {refreshToken} from '../../../services/auth';
import {SceneMap, TabBar, TabView} from 'react-native-tab-view';

const GavelResolver = {
  resolver: yupResolver(schemaGavelBid),
};

export default function GavelOnlineScreen() {
  const {
    control,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm(GavelResolver);
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const focusScreen = useIsFocused();
  const layout = useWindowDimensions();
  const dispatch = useDispatch();

  const initialRoutes = [
    {key: 'direta', title: 'Diretas'},
    {key: 'oferta', title: 'Ofertas'},
  ];

  const [modalAuctionsBid, setModalAuctionsBid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [qtdPages, setQtdPages] = useState(1);
  const [listGavel, setListGavel] = useState<Array<any>>([]);
  const [infoItem, setInfoItem] = useState<any>(null);
  const [routes] = useState(initialRoutes);
  const [index, setIndex] = useState(0);

  const getListGavel = async () => {
    try {
      setIsLoading(true);
      const response = await getAuctions(
        !index ? 'direta' : 'oferta',
        undefined,
        undefined,
        undefined,
        page,
        userInfo?.token,
      );
      setIsLoading(false);
      setQtdPages(response?.result?.qtdPages || 1);
      setListGavel(response?.result?.list || []);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (focusScreen) {
      const timeoutId = setTimeout(() => {
        getListGavel();
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [page, focusScreen, index]);

  function onEndReached() {
    if (page < qtdPages) {
      setPage(page + 1);
    }
  }

  const handlePress = async (data: any) => {
    setIsLoading(true);
    const formatData = {
      value: priceUnmask(data.value || 'R$ 0,00'),
      idUserBid: userInfo?.user?.id,
      idAuction: infoItem?.id,
    };
    await bidAuctions(formatData, userInfo?.token)
      .then(async response => {
        setIsLoading(false);
        setModalAuctionsBid(false);
        setInfoItem(null);
        reset();
        getListGavel();
        getNewToken();
        Toast.show({
          type: 'success',
          text1: response?.data?.message || 'Dados atualizados!',
        });
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  };

  const getNewToken = async () => {
    await refreshToken(
      {refresh: userInfo?.tokenRefresh, type: 'users'},
      userInfo?.token,
    )
      .then(response => {
        const newToken = response?.data?.result?.token;
        dispatch(
          // @ts-ignore
          updateUser({
            ...userInfo,
            token: newToken || userInfo?.token,
            user: response?.data?.result?.user,
          }),
        );
      })
      .catch(error => {
        console.log('error', error);
      });
  };

  const acceptTrade = async (item: any) => {
    setIsLoading(true);
    const formatData = {
      value: item.bid.value,
      idUserBid: item.bid.user_id,
      idAuction: item?.id,
      execute: true,
    };
    await bidAuctions(formatData, userInfo?.token)
      .then(async response => {
        setIsLoading(false);
        getListGavel();
        getNewToken();
        Toast.show({
          type: 'success',
          text1: response?.data?.message || 'Dados atualizados!',
        });
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  };

  const direta = () => {
    if (isLoading) {
      return (
        <ActivityIndicator
          size="large"
          color={theme.colors(appTheme).white}
          style={{marginTop: 40}}
        />
      );
    }
    return (
      <FlatList
        data={listGavel}
        renderItem={({item}) => (
          <GavelItem
            item={item}
            acceptTrade={acceptTrade}
            applyBid={() => {
              setModalAuctionsBid(true);
              setInfoItem(item);
            }}
            isLoading={isLoading}
          />
        )}
        keyExtractor={item => String(item.id)}
        style={{width: '100%'}}
        contentContainerStyle={{
          paddingBottom: 60,
          paddingTop: 20,
          alignItems: 'center',
        }}
        indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
        onEndReached={onEndReached}
        onEndReachedThreshold={0.3}
      />
    );
  };

  const oferta = () => {
    if (isLoading) {
      return (
        <ActivityIndicator
          size="large"
          color={theme.colors(appTheme).white}
          style={{marginTop: 40}}
        />
      );
    }
    return (
      <FlatList
        data={listGavel}
        renderItem={({item}) => (
          <GavelItem
            item={item}
            acceptTrade={acceptTrade}
            applyBid={() => {
              setModalAuctionsBid(true);
              setInfoItem(item);
            }}
            isLoading={isLoading}
          />
        )}
        keyExtractor={item => String(item.id)}
        style={{width: '100%'}}
        contentContainerStyle={{
          paddingBottom: 60,
          paddingTop: 20,
          alignItems: 'center',
        }}
        indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
        onEndReached={onEndReached}
        onEndReachedThreshold={0.3}
      />
    );
  };

  const renderScene = SceneMap({
    direta,
    oferta,
  });

  const renderTabBar = (propsTabView: any) => {
    return (
      <TabBar
        {...propsTabView}
        renderTabBarItem={renderTabBarItem}
        indicatorStyle={{
          backgroundColor: 'white',
          elevation: 0,
          height: 3,
        }}
        style={{
          alignSelf: 'center',
          backgroundColor: theme.colors(appTheme).black[500],
          elevation: 0,
          shadowOffset: {
            height: 0,
            width: 0,
          },
          shadowColor: 'transparent',
          shadowRadius: 0,
          shadowOpacity: 1,
          width: '100%',
        }}
        contentContainerStyle={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
        renderIndicator={() => null}
      />
    );
  };

  const renderTabBarItem = (propsTabBar: any) => {
    const {title} = propsTabBar.route;
    const focus = title === initialRoutes[index].title;

    return (
      // @ts-ignore
      <TouchableOpacity
        {...propsTabBar}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 10,
          width: layout.width / 2,
        }}>
        <TextDefault
          text={title}
          color={
            focus
              ? theme.colors(appTheme).main[700]
              : theme.colors(appTheme).white
          }
          fontSize={14}
        />
        <S.BottomMarked
          style={{
            backgroundColor: focus
              ? theme.colors(appTheme).main[700]
              : 'transparent',
          }}
        />
      </TouchableOpacity>
    );
  };

  const onChangeIndex = (indexActual: number) => {
    setIndex(indexActual);
  };

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        <S.ContainerArea appTheme={appTheme}>
          <TextDefault
            fontSize={20}
            color={theme.colors(appTheme).white}
            marginTop={20}
            marginBottom={20}
            text="Leilões disponíveis"
            fontFamily={theme.fonts.family.opensans.semi_bold}
            textAlign="center"
          />
          <TabView
            navigationState={{index, routes}}
            renderScene={renderScene}
            renderTabBar={renderTabBar}
            onIndexChange={onChangeIndex}
            initialLayout={{width: layout.width}}
            style={{
              // height: 50,
              width: '100%',
            }}
          />
        </S.ContainerArea>
        <DefaultModal
          modalVisible={modalAuctionsBid}
          setModalVisible={setModalAuctionsBid}
          onClose={() => {
            setModalAuctionsBid(false);
            setInfoItem(null);
          }}>
          <S.ContainerModal appTheme={appTheme}>
            <View
              style={{
                position: 'absolute',
                left: 0,
                top: -120,
                width: Dimensions.get('window').width / 1.1,
                zIndex: 1,
              }}>
              <Toast config={toastConfig} />
            </View>
            <S.Body>
              <TextDefault
                fontSize={20}
                color={theme.colors(appTheme).white}
                marginBottom={20}
                text="Dar lance"
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
              <Input
                title="Valor do lance"
                errors={errors}
                placeholder="Ex.: R$ 100,00"
                control={control}
                name="value"
                marginTop={10}
                width="100%"
                mask="money"
                hideBorder
                keyboardType="phone-pad"
              />
              <Button
                title="APLICAR"
                onPress={handleSubmit(handlePress)}
                fontFamily={theme.fonts.family.opensans.bold}
                marginTop={20}
                isLoading={isLoading}
              />
            </S.Body>
          </S.ContainerModal>
        </DefaultModal>
        {modalAuctionsBid ? null : <Toast config={toastConfig} />}
      </S.Container>
    </>
  );
}
